module.exports = __webpack_public_path__ + "static/media/gh.bb3bb604.svg";